import { Button as MuiButton } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Enhanced Button component built on top of MUI Button
 * Supports primary/secondary variants and different sizes
 */
const Button = ({ 
  primary = false, 
  size = 'medium', 
  label, 
  children,
  variant,
  ...props 
}) => {
  // Map primary prop to MUI variant if not explicitly set
  const buttonVariant = variant || (primary ? 'contained' : 'outlined');
  
  return (
    <MuiButton
      variant={buttonVariant}
      size={size}
      {...props}
    >
      {children || label}
    </MuiButton>
  );
};

Button.propTypes = {
  primary: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  label: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
};

export default Button;